var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrear(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 35,
    fill: "#1AB8DB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 37C54 37.1642 53.9677 37.3267 53.9049 37.4784C53.842 37.63 53.75 37.7678 53.6339 37.8839C53.5178 38 53.38 38.092 53.2284 38.1549C53.0767 38.2177 52.9142 38.25 52.75 38.25H40.25V50.75C40.25 51.0815 40.1183 51.3995 39.8839 51.6339C39.6495 51.8683 39.3315 52 39 52C38.6685 52 38.3505 51.8683 38.1161 51.6339C37.8817 51.3995 37.75 51.0815 37.75 50.75V38.25H25.25C24.9185 38.25 24.6005 38.1183 24.3661 37.8839C24.1317 37.6495 24 37.3315 24 37C24 36.6685 24.1317 36.3505 24.3661 36.1161C24.6005 35.8817 24.9185 35.75 25.25 35.75H37.75V23.25C37.75 22.9185 37.8817 22.6005 38.1161 22.3661C38.3505 22.1317 38.6685 22 39 22C39.3315 22 39.6495 22.1317 39.8839 22.3661C40.1183 22.6005 40.25 22.9185 40.25 23.25V35.75H52.75C52.9142 35.75 53.0767 35.7823 53.2284 35.8451C53.38 35.908 53.5178 36 53.6339 36.1161C53.75 36.2322 53.842 36.37 53.9049 36.5216C53.9677 36.6733 54 36.8358 54 37Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_80",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_80"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_80",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrear);
export default __webpack_public_path__ + "static/media/crear.ad2132782f5e29731e3780947839dda7.svg";
export { ForwardRef as ReactComponent };